<script setup lang="ts">
import EditIcon from "@/components/icon/editIcon.vue";
import PersonaIcon from "@/components/icon/PersonaIcon.vue";
import MagicStickIcon from "@/components/icon/MagicStickIcon.vue";
import { Popup } from "vant";
import { useRouter } from "vue-router";
import { ref, watch } from "vue";
import StoryBookInfoEdit, {
  StoryBookInfoEditExpose,
} from "@/components/mobile/story/story-book/StoryBookInfoEdit.vue";
import { useStoryBook } from "@/stores/story-book";
// Props
const props = defineProps<{
  show: boolean;
}>();
const emit = defineEmits<{
  (e: "update:show", value: boolean): void;
}>();
// State
const router = useRouter();
const showCreateInfo = ref(false);
const store = useStoryBook();
const storyBookInfoEditRef = ref<StoryBookInfoEditExpose | null>(null);

// Lifecycle
watch(
  () => props.show,
  (value) => {
    if (value) {
      // showCreateInfo.value = false;
      showCreateInfo.value = true;
      storyBookInfoEditRef.value?.reset();
    }
  }
);

const clickAutoGenerate = () => {
  store.initForm();
  router.push(`/story/edit`);
};

// Event Handler
</script>
<template>
  <popup
    :show="show"
    @update:show="emit('update:show', $event)"
    position="center"
    class="w-[350px] py-10"
    round
  >
    <div
      v-if="!showCreateInfo"
      class="flex flex-col items-center justify-center w-full h-full gap-10"
    >
      <div class="flex flex-col items-center justify-center gap-2">
        <persona-icon class="w-[50%] text-base-content/50" />
        <div class="text-lg font-bold text-base-content/50">
          {{ $t("story.newStory") }}
        </div>
      </div>
      <div class="flex flex-col gap-2">
        <!-- <button
          class="w-60 btn rounded btn-sm btn-primary"
          @click="clickAutoGenerate"
        >
          <magic-stick-icon class="icon-base" />
          {{ $t("Buttons.autoGenerate") }}
        </button> -->
        <button
          class="w-60 btn rounded btn-sm btn-primary"
          @click="showCreateInfo = true"
        >
          <edit-icon />
          {{ $t("Buttons.manualCreation") }}
        </button>
        <button
          class="btn w-60 rounded btn-sm"
          @click="emit('update:show', false)"
        >
          {{ $t("Buttons.close") }}
        </button>
      </div>
    </div>
    <story-book-info-edit
      v-else
      ref="storyBookInfoEditRef"
      :visibility="1"
      @on-success="emit('update:show', false)"
      @on-cancel="emit('update:show', false)"
    />
  </popup>
</template>
